module.exports = __webpack_public_path__ + "static/img/empty.e0fb5d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty.png
// module id = vTAX
// module chunks = 1